export const DELETE_HANDBOOK_MODAL_TITLE = "Delete handbook"
export const DELETE_HANDBOOK_MODAL_TEXT = "Are You sure you want to delete the selected handbook?"